import React, {useEffect, useState} from 'react'
import { formatTypes, inputTypes } from '../../../libs/react-mpk/config/constant'
import { FormWrapper } from '../../../libs/react-mpk/wrapper'
import t from 'counterpart'
import { inject, observer } from 'mobx-react'
import service from './Ptkp.service'
import Utils from '../../../libs/custom/Utils'

const PtkpForm = ({envStore, match, history}) => {
  const { inputTypes, definition } = FormWrapper
  const [data, setData] = useState({loading: true, content: {}})
  const [isEdit, setIsEdit] = useState(false)

  // initial data
  useEffect(() => {
    async function initData() {
      if(match.params.id == 'baru') {
        setData({loading: false, content: {}})
        return true
      }

      const res = await service.getOne(match.params.id)
      res.data = Utils.formSerialize(res.data)
      setData({loading: false, content:res.data})
      setIsEdit(true)
    }
    initData()
  }, ['match.params.id'])

  return (
    <FormWrapper
      noValidate
      customRules={{
        dari: 'required|size:4',
        ke: 'required|size:4'
      }}
      loading={data.loading}
      actions={[
        {
          label: 'Reload',
          iconClassName: 'mdi mdi-reload'
        }
      ]}
      backTo={`/onpremise/ptkp`}
      baseId="mod-form-sample"
      title={t.translate('modules.ptkp.formTitle')}
      // hintMessage={t.translate('modules.form.hint.message')}
      hintShowIcon={false}
      defaultData={data.content}
      definitions={[
        // =====
        {
          inputType: inputTypes.INPUT_MASK,
          label: 'Dari (Tahun)',
          key: 'dari',
          width: '49%',
          style: {marginRight: '2%'},
          mask: '****',
          alwaysShowMask: true,
          disabled: isEdit,
          allowNegative: false
        },{
          inputType: inputTypes.INPUT_MASK,
          label: 'Ke (Tahun)',
          key: 'ke',
          width: '49%',
          mask: '****',
          alwaysShowMask: true,
          disabled: isEdit,
          allowNegative: false
        },
        {
          inputType: inputTypes.INPUT_MASK_NUMBER,
          label: 'Pribadi (Rp)',
          key: 'pribadi',
          width: '49%',
          style: {marginRight: '2%'},
          thousandSeparator: '.',
          decimalSeparator: ',',
          isNumericString: true,
          validation: 'required|numeric'
        },{
          inputType: inputTypes.INPUT_MASK_NUMBER,
          label: 'Tanggungan (Rp)',
          key: 'tanggungan',
          width: '49%',
          thousandSeparator: '.',
          decimalSeparator: ',',
          isNumericString: true,
          validation: 'required|numeric'
        },
        {
          inputType: inputTypes.INPUT_MASK_NUMBER,
          label: 'TK/0 (Rp)',
          key: 'tk0',
          width: '24%',
          style: {marginRight: '2%'},
          thousandSeparator: '.',
          decimalSeparator: ',',
          isNumericString: true,
          validation: 'required|numeric'
        },{
          inputType: inputTypes.INPUT_MASK_NUMBER,
          label: 'TK/1 (Rp)',
          key: 'tk1',
          width: '23%',
          style: {marginRight: '2%'},
          thousandSeparator: '.',
          decimalSeparator: ',',
          isNumericString: true,
          validation: 'required|numeric'
        },{
          inputType: inputTypes.INPUT_MASK_NUMBER,
          label: 'TK/2 (Rp)',
          key: 'tk2',
          width: '23%',
          style: {marginRight: '2%'},
          thousandSeparator: '.',
          decimalSeparator: ',',
          isNumericString: true,
          validation: 'required|numeric'
        },{
          inputType: inputTypes.INPUT_MASK_NUMBER,
          label: 'TK/3 (Rp)',
          key: 'tk3',
          width: '24%',
          thousandSeparator: '.',
          decimalSeparator: ',',
          isNumericString: true,
          validation: 'required|numeric'
        },{
          inputType: inputTypes.INPUT_MASK_NUMBER,
          label: 'K/0 (Rp)',
          key: 'k0',
          width: '24%',
          style: {marginRight: '2%'},
          thousandSeparator: '.',
          decimalSeparator: ',',
          isNumericString: true,
          validation: 'required|numeric'
        },{
          inputType: inputTypes.INPUT_MASK_NUMBER,
          label: 'K/1 (Rp)',
          key: 'k1',
          width: '23%',
          style: {marginRight: '2%'},
          thousandSeparator: '.',
          decimalSeparator: ',',
          isNumericString: true,
          validation: 'required|numeric'
        },{
          inputType: inputTypes.INPUT_MASK_NUMBER,
          label: 'K/2 (Rp)',
          key: 'k2',
          width: '23%',
          style: {marginRight: '2%'},
          thousandSeparator: '.',
          decimalSeparator: ',',
          isNumericString: true,
          validation: 'required|numeric'
        },{
          inputType: inputTypes.INPUT_MASK_NUMBER,
          label: 'K/3 (Rp)',
          key: 'k3',
          width: '24%',
          thousandSeparator: '.',
          decimalSeparator: ',',
          isNumericString: true,
          validation: 'required|numeric'
        },{
          inputType: inputTypes.INPUT_MASK_NUMBER,
          label: 'K/I/0 (Rp)',
          key: 'ki0',
          width: '24%',
          style: {marginRight: '2%'},
          thousandSeparator: '.',
          decimalSeparator: ',',
          isNumericString: true,
          validation: 'required|numeric'
        },{
          inputType: inputTypes.INPUT_MASK_NUMBER,
          label: 'K/I/1 (Rp)',
          key: 'ki1',
          width: '23%',
          style: {marginRight: '2%'},
          thousandSeparator: '.',
          decimalSeparator: ',',
          isNumericString: true,
          validation: 'required|numeric'
        },{
          inputType: inputTypes.INPUT_MASK_NUMBER,
          label: 'K/I/2 (Rp)',
          key: 'ki2',
          width: '23%',
          style: {marginRight: '2%'},
          thousandSeparator: '.',
          decimalSeparator: ',',
          isNumericString: true,
          validation: 'required|numeric'
        },{
          inputType: inputTypes.INPUT_MASK_NUMBER,
          label: 'K/I/3 (Rp)',
          key: 'ki3',
          width: '24%',
          thousandSeparator: '.',
          decimalSeparator: ',',
          isNumericString: true,
          validation: 'required|numeric'
        }
        // -----
      ]}
      onSubmit={async (data, callback) => {
        var res = {}
        try {
          data = Utils.formNormalize(data)
          if(match.params.id == 'baru') {
            res = await service.post(data)
          } else {
            res = await service.put(data)
          }
          callback(t.translate('global.dataTelahDiSimpan'), false)
          history.push('/onpremise/ptkp')
        } catch(e) {
          callback(e, true, false)
        }
      }}
    />
  )
}

export default inject('envStore')(observer(PtkpForm))
